import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

function VerticalSeparator() {
  return (
    <Box
      border={{
        right: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    />
  )
}

export default VerticalSeparator
